module.exports = __webpack_public_path__ + "static/programming_paradigms-4a88d6b27829a70b68cdad414fc1cbfa.png";